import { CellCameraIProps, CloudCameraOptionIProps } from '../types/types'
import { EmptyCell } from './EmptyCell'
import { VideoWallTile } from './VideoWallTile'

interface IProps {
  cell: CellCameraIProps | null
  index: number
  availableCameras: CloudCameraOptionIProps[]
  camerasLoading: boolean
  hasCamerasError: boolean
  onRetryCameras: () => void
}

/**
 * A single grid slot. Renders the camera feed when a camera is placed, otherwise
 * the empty "add camera" picker.
 */
export const VideoWallCell = ({
  cell,
  index,
  availableCameras,
  camerasLoading,
  hasCamerasError,
  onRetryCameras,
}: IProps) => {
  if (!cell) {
    return (
      <EmptyCell
        availableCameras={availableCameras}
        camerasLoading={camerasLoading}
        hasCamerasError={hasCamerasError}
        index={index}
        onRetryCameras={onRetryCameras}
      />
    )
  }

  return <VideoWallTile camera={cell} index={index} />
}
